import React, { useEffect } from 'react';
import { useAdminStore } from '../../store/adminStore'; // Adjust path to your store
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Globe } from 'lucide-react';
import api from '../../services/apiServices';

const LocaleSelector = ({ className }) => {
  const { locale, countries, setLocale, setCountries } = useAdminStore((state) => state);

  // Initial Fetch of Countries if the store is empty
  useEffect(() => {
    if (countries.length === 0) {
      api.get('/admin/common/active-countries')
        .then(res => {
           const countryList = res.data || [];
           setCountries(countryList);

           // If no locale is currently selected, default to the first one.
           // Read the live store value (not the closed-over `locale`) so a locale
           // set elsewhere while this request was in flight isn't clobbered.
           if (!useAdminStore.getState().locale && countryList.length > 0) {
               setLocale(countryList[0].country_code);
           }
        })
        .catch(err => console.error("Failed to fetch countries:", err));
    }
  }, [countries.length, setCountries, setLocale]);

  return (
    <div className={`flex items-center gap-2 border px-3 py-1.5 rounded-md bg-gray-50 ${className}`}>
      <Globe className="w-4 h-4 text-gray-500" />
      <Select value={locale || ''} onValueChange={setLocale}>
        <SelectTrigger className="w-[140px] h-8 border-none bg-transparent focus:ring-0 p-0 shadow-none focus:outline-none text-sm font-medium">
          <SelectValue placeholder="Select Country" />
        </SelectTrigger>
        <SelectContent>
          {countries.map((c) => (
            <SelectItem key={c.country_code} value={c.country_code}>
              {c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LocaleSelector;